<template>
    <div
        ref="backdrop"
        v-show="actuallyOpen"
        role="dialog"
        aria-modal="true"
        :aria-label="ariaLabel"
        class="cz2__blur-modal-backdrop"
        :class="{
            'cz2__blur-modal-backdrop--open': isOpen,
        }"
        :inert="!isOpen"
    >
        <focus-lock>
            <div class="cz2__blur-modal-content">
                <!-- Can't use ConditionalSwiper since it always emits a tag -->
                <swiper
                    v-if="swiperize"
                    :hideScrollbar="true"
                >
                    <div
                        v-if="isSpellingBee && !isInspectModal"
                        class="cz2__blur-modal-content-wrapper"
                    >
                        <header
                            :class="{ absolute: absoluteHeader }"
                            class="cz2__blur-modal-header"
                        >
                            <img
                                class="cz2__sb-pop-logo"
                                src="../../assets/images/branded/sb-final/SB-POP_Yourself_Logo@2x.webp"
                                alt="Spelling Bee Pop Logo"
                            >

                            <button
                                type="button"
                                aria-label="Close"
                                @click="close"
                                class="cz2__blur-modal-close"
                            />
                        </header>

                        <img
                            class="cz2__sb-pop-logo-mobile"
                            src="../../assets/images/branded/sb-final/SB-Logo_1_M@2x.webp"
                            alt="Spelling Bee Pop Logo"
                        >

                        <slot @close="close" />
                    </div>
                    <template v-else>
                        <header
                            :class="{ absolute: absoluteHeader }"
                            class="cz2__blur-modal-header"
                        >
                            <img
                                src="../../assets/images/pop-yourself-logo.svg"
                                alt="Pop! Yourself Logo"
                                aria-hidden="true"
                                class="cz2__blur-modal-logo"
                            >

                            <button
                                v-if="isSpellingBee && isOpen"
                                type="button"
                                aria-label="Close"
                                @click="close"
                                class="cz2__blur-modal-close"
                            />
                        </header>

                        <slot @close="close" />
                    </template>
                </swiper>

                <template v-if="!swiperize">
                    <div
                        v-if="isSpellingBee && !isInspectModal"
                        class="cz2__blur-modal-content-wrapper"
                    >
                        <header
                            :class="{ absolute: absoluteHeader }"
                            class="cz2__blur-modal-header"
                        >
                            <img
                                class="cz2__sb-pop-logo"
                                src="../../assets/images/branded/sb-final/SB-POP_Yourself_Logo@2x.webp"
                                alt="Spelling Bee Pop Logo"
                            >

                            <button
                                type="button"
                                aria-label="Close"
                                @click="close"
                                class="cz2__blur-modal-close"
                            />
                        </header>

                        <img
                            class="cz2__sb-pop-logo-mobile"
                            src="../../assets/images/branded/sb-final/SB-Logo_1_M@2x.webp"
                            alt="Spelling Bee Pop Logo"
                        >

                        <slot @close="close" />
                    </div>
                    <template v-else>
                        <header
                            :class="{ absolute: absoluteHeader }"
                            class="cz2__blur-modal-header"
                        >
                            <div class="cz2__blur-modal-logo-wrapper">
                                <img
                                    src="../../assets/images/funko-logo-black.svg"
                                    :alt="$t('LOGO_FUNKO')"
                                    width="32"
                                    height="11"
                                >
                                <img
                                    src="../../assets/images/pop-yourself-logo.svg"
                                    alt="Pop! Yourself Logo"
                                    aria-hidden="true"
                                    class="cz2__blur-modal-logo"
                                >
                            </div>

                            <button
                                type="button"
                                aria-label="Close"
                                @click="close"
                                class="cz2__blur-modal-close"
                            />
                        </header>
                        <slot @close="close" />
                    </template>
                </template>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-stars, .cz2__sb-pop-logo, .cz2__sb-logo, .cz2__sb-pop-logo-k {
            display: none;
        }

        .cz2__blur-modal-content-wrapper {
            height: 100%;
            width: 100%;
            min-height: fit-content;
        }

        .cz2__blur-modal-backdrop {
            position: fixed;

            // Allowance for bouncing below the fold.
            top: -120px;
            padding-top: 120px;

            // Include padding.
            height: calc(100% + 120px);

            left: 0;
            width: 100%;

            z-index: 99999;

            background-color: rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(20px);

            will-change: transform;

            transform: translate3d(0, -100%, 0);

            pointer-events: none;

            // Special styles to handle extra divs added by focus-lock
            div:has([data-lock]) {
                width: 100%;
                height: 100%;
            }

            &.cz2__blur-modal-backdrop--open {
                pointer-events: auto;
            }

            .cz2__blur-modal-content {
                display: flex;
                flex-direction: column;
                height: 100%;
                max-height: 100%;
                overflow-y: auto;
                overflow-x: hidden;
            }

            .cz2__blur-modal-header {
                margin-bottom: 16px;
                padding: 16px 24px;

                width: 100%;

                display: flex;
                justify-content: space-between;

                // Gives the renderer more room in the inspect modal - no point wasting space for a logo that does nothing
                &.absolute {
                    position: absolute;
                    // Same padding as the main area;
                    top: 120px;
                    z-index: 99999;
                }
            }

            .cz2__blur-modal-logo-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;
            }

            .cz2__blur-modal-logo {
                width: 75px;
                height: 66px;
            }

            .cz2__blur-modal-close {
                z-index: 99999;
                margin-top: 8px;

                width: 32px;
                height: 32px;
                background: transparent url(../../assets/icons/close-white.svg) no-repeat center/contain;
            }

            @include respond-above(xl) {
                .cz2__blur-modal-close {
                    width: 56px;
                    height: 56px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__blur-modal-logo {
            height: 195px;
            width: 222px;
        }
        .cz2__blur-modal-close {
            width: 56px;
            height: 56px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__blur-modal-backdrop {
            background-image: url('../../assets/images/branded/sb-final/SB-Background-Pattern-1_M@2x.jpg');
            background-size: cover;
            backdrop-filter: none;

            @include respond-above(sm) {
                background-image: url('../../assets/images/branded/sb-final/SB-Background-pattern-2_D@2x.jpg');
                background-size: cover;
                backdrop-filter: none;
            }
        }

        .cz2__blur-modal-backdrop {
            .cz2__blur-modal-header {
                width: 100%;
                height: 0;
                margin: 0;
                padding: 0;
                top: 0px;
                justify-content: flex-end;

                @include respond-above(sm) {
                    // Escape the container and make this full width.
                    width: var(--vw100, 100vw);
                    left: 50%;
                    position: relative;
                    transform: translate(-50%, 0);
                }
            }

            .cz2__blur-modal-close {
                margin-top: 23px;
                margin-right: -18px;

                @include respond-above(sm) {
                    margin-top: 0px;
                    margin-right: 32px;
                }
            }
        }

        .cz2__blur-modal-content-wrapper {
            height: auto;
            width: 100%;
            min-height: fit-content;
        }

        .cz2__blur-modal-content-wrapper {
            max-width: 700px;
            margin: 0px auto;

            border-image-source: url("../../assets/images/branded/sb-final/SB-Border 1_M@2x.webp");

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            padding: 0px 40px;

            @include respond-above(sm) {
                border-image-source: url('../../assets/images/branded/sb-final/SB-Border 4_D@2x.webp');

                border-width: 50px;
                border-image-width: 50px;
                border-image-slice: 100 fill;

                padding-bottom: 40px;
            }
        }

        .cz2__blur-modal-content {
            padding: 0px;
            padding-top: 0;
            padding-bottom: 0;

            @include respond-above(sm) {
                padding: 32px;
            }

            .swiper-scrollbar-wrapper {
                display: none !important;
            }
        }

        .cz2__blur-modal-close {
            background: transparent url(../../assets/icons/close-sb.svg) no-repeat center/contain !important;
            background-color: #112344 !important;
            border: 4px solid color(sbDarkGold) !important;
            right: 24px;
        }

        .cz2__blur-modal-logo {
            display: none;
        }

        .cz2__sb-pop-logo-mobile {
            display: block;
            width: 262px;

            margin: 0 auto;
            margin-top: 38px;
            margin-bottom: 24px;
        }

        .cz2__sb-logo-d {
            display: none;
        }

        @include respond-above(lg) {
            .cz2__sb-pop-logo-mobile {
                display: none;
            }
            .cz2__sb-pop-logo {
                display: block;
                transform: scale(0.8);
                left: 24px;
            }
            .cz2__blur-modal-content-wrapper {
                height: auto;
                width: 100%;
            }
        }
    }

    #cz2.cz2__is-sb.cz2__is-kiosk {
        .cz2__blur-modal-content {
            padding: 0;

            .cz2__sb-logo-d {
                display: none;
            }

            .cz2__sb-logo-m {
                display: none;
            }

            .swiper-slide--kiosk {
                padding: 32px;
            }

            .cz2__blur-modal-content-wrapper {
                max-width: none;
            }
        }

        // .cz2__blur-modal-header {
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;
        //     position: relative;
        // }
        // .cz2__blur-modal-close {
        //     position: fixed;
        //     top: 0;
        //     right: 0;
        // }
        // .cz2__step-groups li {
        //     padding-left: 24px;
        // }

        // .cz2__blur-modal-backdrop {
        //     padding-bottom: 64px;
        // }
    }
</style>
<script>
    // eslint-disable-next-line no-unused-vars
    import { spring, timeline, animate } from 'motion';
    import FocusLock from 'vue-focus-lock';

    import Swiper from './Swiper.vue';

    export default {
        components: {
            Swiper,
            FocusLock,
        },
        props: {
            isOpen: {
                type: Boolean,
                default: false,
            },
            alwaysOpen: {
                type: Boolean,
                default: true,
            },
            absoluteHeader: {
                type: Boolean,
                default: false,
            },
            swiperize: {
                type: Boolean,
                default: false,
            },
            ariaLabel: {
                type: String,
                default: '',
            },
            isInspectModal: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                actuallyOpen: this.alwaysOpen,
            };
        },
        watch: {
            isOpen() {
                this.onOpen();
            },
        },
        mounted() {
            if (this.isOpen) {
                this.onOpen();
            }

            // get cz2__blur-modal-close button
            const closeBtn = document.querySelector('.cz2__blur-modal-close');
            // set position of close button
            closeBtn.style.top = `${window.scrollY + 16}px`;
        },
        computed: {
            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },
        },
        methods: {
            isIos() {
                return /iPhone|iPad|iPod/.test(navigator.platform);
            },

            onOpen() {
                if (this.isOpen) {
                    this.actuallyOpen = true;

                    this.animateIn();
                } else {
                    this.animateOut();
                }
            },

            animateIn() {
                const element = this.$refs.backdrop;

                if (this.closeAnimation) {
                    try {
                        this.closeAnimation.cancel();
                    } catch (e) {
                        // Nothing.
                    }
                    this.closeAnimation = null;
                }

                // Need to wait for the backdrop to be added to DOM.
                this.$nextTick(() => {
                    // Make
                    element.style.display = 'block';

                    const PAD_OFFSET = 120;

                    const height = element.offsetHeight - PAD_OFFSET;
                    element.style.transform = `translate3d(0, -${height}px, 0)`;

                    setTimeout(() => {
                        this.$nextTick(() => {
                            timeline(
                                [
                                    [
                                        this.$refs.backdrop,
                                        {
                                            transform: [`translate3d(0, -${height}px, 0)`, 'translate3d(0, 30px, 0)'],
                                        },
                                        // iPhone hardware lags since it can't maintain 60 fps during the initial blurring.
                                        { duration: this.isIos() ? 0.255 : 0.25 },
                                    ],
                                    [
                                        this.$refs.backdrop,
                                        {
                                            transform: ['translate3d(0, -5px, 0)'],
                                        },
                                        { duration: 0.25 },
                                    ],
                                    [
                                        this.$refs.backdrop,
                                        {
                                            transform: ['translate3d(0, 0px, 0)'],
                                        },
                                        { stiffness: 616 },
                                        { mass: 1 },
                                        { damping: 30 },
                                        { easing: spring(), duration: 0.3 },
                                    ],
                                ],
                            ).finished.then(() => {
                                this.openAnimation = null;
                            });
                        });
                    }, 10);
                });
            },

            animateOut() {
                const element = this.$refs.backdrop;

                if (this.openAnimation) {
                    try {
                        this.openAnimation.cancel();
                    } catch (e) {
                        // Nothing.
                    }
                    this.openAnimation = null;
                }

                this.closeAnimation = animate(element, {
                    transform: ['translate3d(0, 0, 0) scale3d(1, 1, 1)', 'translate3d(0, -100%, 0) scale3d(1, 0.3, 1)'],
                }, {
                    duration: this.isIos() ? 0.4 : 0.4,
                    easing: 'ease-out',
                }).finished.then(() => {
                    this.closeAnimation = null;

                    if (this.alwaysOpen) {
                        // Nothing.
                    } else {
                        this.actuallyOpen = false;

                        this.$emit('actuallyClosed');
                    }
                });
            },

            close() {
                this.$emit('closed');
            },
        },
    };
</script>
